import { LinkType } from '../types.js';
import { serializeProps } from './serializer.js';
export async function loadMicrofrontend(mfServer, props, options) {
    const renderUrl = getRenderUrl(mfServer, props);
    const finalHeaders = new Headers(options?.headers);
    finalHeaders.set('Content-Type', 'text/plain');
    const resp = await fetch(renderUrl, {
        headers: finalHeaders,
        credentials: options?.cookieCredentials,
    });
    if (!resp.ok) {
        return Promise.reject(new Error(`Failed to fetch '${renderUrl}'`));
    }
    if (!resp.body) {
        return Promise.reject(new Error(`Invalid response from '${renderUrl}'`));
    }
    const contentType = resp.headers.get('Content-Type');
    if (!contentType?.startsWith('text/plain')) {
        return Promise.reject(new Error(`Invalid "Content-Type": '${contentType}'`));
    }
    return resp;
}
export function getDependencies(linkHeader) {
    const styles = [];
    const scripts = [];
    if (!linkHeader) {
        return {
            styles,
            scripts,
        };
    }
    const links = linkHeader.split(',').map(l => l.trimStart());
    for (const link of links) {
        const [uri, attribs] = link.split(';').map(s => s.trim());
        const url = uri.slice(1, -1); // remove '<' and '>'
        const params = new URLSearchParams(attribs.split(' ').map(attr => {
            const [key, value] = attr.trim().split('=');
            return [key, value.slice(1, -1)];
        }));
        if (params.get('rel') === 'stylesheet') {
            styles.push(url);
        }
        const linkType = params.get('data-type');
        if (linkType === LinkType.scriptDependency) {
            scripts.push(url);
        }
    }
    return { styles, scripts };
}
function getRenderUrl(mfServer, props) {
    const url = new URL(mfServer);
    const params = serializeProps(props);
    for (const [key, val] of Object.entries(params)) {
        url.searchParams.set(key, val);
    }
    return url.toString();
}
